import { render, staticRenderFns } from "./FloatingInput.vue?vue&type=template&id=5a8204c3&"
import script from "./FloatingInput.vue?vue&type=script&lang=ts&"
export * from "./FloatingInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports